import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  Grid,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { HttpService } from "../../../service/HttpService";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80vw",
  maxWidth: "100%",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 3,
  p: 4,
};

const labelStyle = {
  fontWeight: 500,
  fontSize: "16px",
  marginBottom: "4px",
};

const inputStyle = {
  background: "#f7f9fc",
  borderRadius: "6px",
};

function ViewCutsTrayModal({ open, handleClose, scheduleId }) {
  const httpService = new HttpService();
  const [details, setDetails] = useState([]);

  const fetchsCutsTraydata = async () => {
    try {
      const res = await httpService.get(
        `motherplant/mother_task/${scheduleId}`
      );
      setDetails(res?.data || []);
    } catch (e) {
      setDetails([]);
    }
  };
  useEffect(() => {
    fetchsCutsTraydata();
  }, []);
  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Typography variant="h5" fontWeight={600}>
            View Cuts and Tray Number
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Grid container spacing={2} marginTop={2}>
          {details && details.length > 0 ? (
            details.map((row, idx) => (
              <React.Fragment key={idx}>
                <Grid item xs={12} sm={6} md={2.4}>
                  <Typography sx={labelStyle}>Plant Name</Typography>
                  <div className="form_field_wrapper">
                    <TextField
                      value={row.plant_name || ""}
                      size="small"
                      fullWidth
                      InputProps={{ readOnly: true, sx: inputStyle }}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={2.4}>
                  <Typography sx={labelStyle}>Mother Plant METRC ID</Typography>
                  <div className="form_field_wrapper">
                    <TextField
                      value={row.matric_id || ""}
                      size="small"
                      fullWidth
                      InputProps={{ readOnly: true, sx: inputStyle }}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} sm={2} md={2.4}>
                  <Box sx={{ minWidth: 200, width: 10 }}>
                    <Typography sx={labelStyle}>Number of Cuts</Typography>
                    <div className="form_field_wrapper">
                      <TextField
                        value={row.no_cuts || ""}
                        size="small"
                        fullWidth
                        InputProps={{ readOnly: true, sx: inputStyle }}
                      />
                    </div>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={2.4}>
                  <Box sx={{ minWidth: 200, width: 10 }}>
                    <Typography sx={labelStyle}>Tray Number</Typography>
                    <div className="form_field_wrapper">
                      <TextField
                        value={row.tray_no || ""}
                        size="small"
                        fullWidth
                        InputProps={{ readOnly: true, sx: inputStyle }}
                      />
                    </div>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={2.4}>
                  <Typography sx={labelStyle}>Tray ID</Typography>
                  <div className="form_field_wrapper">
                    <TextField
                      value={row.tray_id || ""}
                      size="small"
                      fullWidth
                      InputProps={{ readOnly: true, sx: inputStyle }}
                    />
                  </div>
                </Grid>
              </React.Fragment>
            ))
          ) : (
            <Grid item xs={12}>
              <Typography>No data available.</Typography>
            </Grid>
          )}
        </Grid>
      </Box>
    </Modal>
  );
}

export default ViewCutsTrayModal;
